import { DashboardCard2 } from "@/ui2/molecules/DashboardCard2";
import { Input } from "react-aria-components";

export function MemberProfileMedicationManagementServices() {
  return (
    <DashboardCard2
      title="Medication Management Services"
      classNameChildren="tw:flex tw:items-center tw:gap-2"
    >
      <Input checked type="checkbox" className="AddPatientInput tw:h-4" disabled />
      Medication Consult Requested
    </DashboardCard2>
  );
}
